<template>
  <div v-if="show"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
    <div class="bg-white p-8 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-bold text-gray-800">Message Settings</h2>
        <button @click="$emit('close')" class="text-gray-600 hover:text-gray-800 focus:outline-none">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
            </path>
          </svg>
        </button>
      </div>
      <div class="mb-4">
        <label for="messageType" class="block text-sm font-medium text-gray-700">Message Type</label>
        <select v-model="messageType" id="messageType" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md">
          <option value="message">Student Message</option>
          <option value="intro">Introduction</option>
          <option value="guide">Guide</option>
        </select>
      </div>

      <div>
        <vue-editor v-model="message" :editor-toolbar="customToolbar"></vue-editor>
      </div>
      <div class="flex justify-end space-x-3 pt-4">
        <button @click="$emit('close')"
          class="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
          Cancel
        </button>
        <button @click="save"
          class="px-4 py-2 bg-blue-600 border border-transparent rounded-md text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { surveyApi } from '@/api/surveyManagement';

export default {
  name: 'StudentMessageModal',
  components: {
    VueEditor
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  watch:{
    async show(val){
      if (val)
      {
        this.messageType = 'message'
        this.settings = await surveyApi.getInstitutionSettings();
        this.message = this.settings.studentMessage;
      }
    },
    messageType(val){
      if (val == "message")
      {
        this.message = this.settings.studentMessage;
      }
      else if (val == "intro")
      {
        this.message = this.settings.introduction
      }
      else
        this.message = this.settings.guide
    }
  },
  data() {
    return {
      settings: {},
      message: '',
      customToolbar: [
        [{ 'header': [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'align': [] }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['link', 'code-block'],
        ['clean']
      ],
      messageType: 'message'
    }
  },
  async mounted(){
    
  },
  methods:{
    async save(){
      if (this.messageType == 'message')
        this.settings.studentMessage = this.message
      else if (this.messageType == 'intro')
        this.settings.introduction = this.message
      else
        this.settings.guide = this.message

      await surveyApi.putInstitutionSettings(this.settings)
      alert('This message has been saved')
    }
  }
}
</script>

<style lang="scss" scoped></style>